import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Legacy Bearer header fallback (for tokens still in localStorage from older sessions).
// Auth is now carried by httpOnly cookie set by the backend on login/register.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("archivio_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// ===== Short-lived download token cache (10 min TTL) =====
let _dlToken = null;
let _dlExpiresAt = 0;
let _dlFetchPromise = null;

export async function getDownloadToken() {
  const now = Date.now();
  // Refresh 60s before expiry
  if (_dlToken && now < _dlExpiresAt - 60_000) return _dlToken;
  if (_dlFetchPromise) return _dlFetchPromise;
  _dlFetchPromise = api
    .post("/auth/download-token")
    .then((r) => {
      _dlToken = r.data.token;
      _dlExpiresAt = now + (r.data.ttl || 600) * 1000;
      return _dlToken;
    })
    .catch(() => null)
    .finally(() => { _dlFetchPromise = null; });
  return _dlFetchPromise;
}

export function clearDownloadToken() {
  _dlToken = null;
  _dlExpiresAt = 0;
}

// Sync accessor for <img src>: uses cached token if present.
// If not cached, returns URL without token — caller should preload getDownloadToken().
export const fileUrl = (docId) => {
  if (_dlToken && Date.now() < _dlExpiresAt) {
    return `${API}/documents/${docId}/file?token=${encodeURIComponent(_dlToken)}`;
  }
  return `${API}/documents/${docId}/file`;
};

// Async openers for direct downloads — fetch fresh token then trigger download.
export async function openFile(docId) {
  const t = await getDownloadToken();
  window.open(`${API}/documents/${docId}/file${t ? `?token=${encodeURIComponent(t)}` : ""}`, "_blank");
}

export async function openFolderZip(folderId) {
  const t = await getDownloadToken();
  window.open(`${API}/folders/${folderId}/zip${t ? `?token=${encodeURIComponent(t)}` : ""}`, "_blank");
}

export async function openFiscalReport(year) {
  const t = await getDownloadToken();
  window.open(`${API}/reports/fiscal/${year}${t ? `?token=${encodeURIComponent(t)}` : ""}`, "_blank");
}

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const startGoogleAuth = () => {
  const redirectUrl = window.location.origin + "/auth/callback";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

// Kept for backwards-compat with existing code — now use cached download token.
export const folderZipUrl = (folderId) => {
  if (_dlToken && Date.now() < _dlExpiresAt) {
    return `${API}/folders/${folderId}/zip?token=${encodeURIComponent(_dlToken)}`;
  }
  return `${API}/folders/${folderId}/zip`;
};

export const reportPdfUrl = (year) => {
  if (_dlToken && Date.now() < _dlExpiresAt) {
    return `${API}/reports/fiscal/${year}?token=${encodeURIComponent(_dlToken)}`;
  }
  return `${API}/reports/fiscal/${year}`;
};
